export function analyticsIdentifyName(name: string | null | undefined): {
  firstName?: string;
  lastName?: string;
} {
  if (!name) {
    return {};
  }

  const nameParts = name.trim().split(" ");

  if (nameParts.length === 0) {
    return {};
  }

  if (nameParts.length === 1) {
    return {
      firstName: nameParts[0],
    };
  }

  return {
    firstName: nameParts[0],
    lastName: nameParts.slice(1).join(" "),
  };
}
